export const SET_GROUP_ORDER_DATA = 'SET_GROUP_ORDER_DATA';
export const setGroupOrderData = (data: any) => {
  return {
    payload: data,
    type: SET_GROUP_ORDER_DATA
  };
};

export const SET_GROUP_ORDER_CART_DATA = 'SET_GROUP_ORDER_CART_DATA';
export const setGroupOrderCartData = (data: any) => {
  return {
    payload: data,
    type: SET_GROUP_ORDER_CART_DATA
  };
};

export const SET_INTERVAL_GROUP_ORDER_DATA = 'SET_INTERVAL_GROUP_ORDER_DATA';
export const setIntervalGroupOrderData = (data: any) => {
  return {
    payload: data,
    type: SET_INTERVAL_GROUP_ORDER_DATA
  };
};

export const ADD_GROUP_ORDER_GOODS = 'ADD_GROUP_ORDER_GOODS';
export const addGroupOrderGoods = (data: any) => {
  return {
    payload: data,
    type: ADD_GROUP_ORDER_GOODS
  };
};

export const SUB_GROUP_ORDER_GOODS = 'SUB_GROUP_ORDER_GOODS';
export const subGroupOrderGoods = (data: any) => {
  return {
    payload: data,
    type: SUB_GROUP_ORDER_GOODS
  };
};

export const SET_FREE_SHIPPING_PROGRESS = 'SET_FREE_SHIPPING_PROGRESS';
export const setFreeShippingProgress = (data: any) => {
  return {
    payload: data,
    type: SET_FREE_SHIPPING_PROGRESS
  };
};
